import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledSelectedFiltersBar = styled.div`
  .selected-filter-button {
    border-radius: ${toRem(8)};
    color: ${baseVariables.color.base10};
    display: inline;
    background-color: ${baseVariables.color.neutral20};
    padding: ${toRem(2)} 0;
  }

  .hidden-pills-container {
    position: absolute;
    visibility: hidden;
    left: -9999;
    top: 0;
  }
`;
